export default "__VITE_ASSET__BlV18Bmd__"